import { clsx } from 'clsx'
import { Scroll } from 'component/Scroll'
import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { ItemCard } from 'page/ProfileScreen/FullProfilePage/ItemCard'
import { FullbodyProvider, useFullbody } from 'page/ProfileScreen/FullProfilePage/Store'
import css from './FullPhotoSelect.module.scss'

const Content = observer(() => {
  const full = useFullbody()
  const single = !full.carousel.many

  return <Space wide tall center>
    <Scroll className={css.scroll} drag>
      <Space className={clsx(css.content, single && css.single)}>
        <Space gap={12} pad={[0, 16]}>
          {full.carousel.items.map((item, index) => <ItemCard key={index} item={item} />)}
        </Space>
      </Space>
    </Scroll>
  </Space>
})

export function FullPhotoSelect() {
  return <FullbodyProvider>
    <Content />
  </FullbodyProvider>
}
